export default __webpack_public_path__ + "static/B0045-3db3e680033cbd9ca8d8fe834283e03c.png";